import React, { useEffect, useState } from "react"
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Spinner } from 'reactstrap';
import classes from './PictureBlastModal.module.scss';
import ThumbUpAltOutlinedIcon from '@mui/icons-material/ThumbUpAltOutlined';
import ThumbDownOutlinedIcon from '@mui/icons-material/ThumbDownOutlined';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import ThumbDownAltIcon from '@mui/icons-material/ThumbDownAlt';
import ArrowBackIosOutlinedIcon from '@mui/icons-material/ArrowBackIosOutlined';
import { boxiGreen, boxiPrimary, boxiRed } from "../../../../assets/style/colors";
import { TableContainer, Button as Button2, Table, TableHead, TableBody, TableRow, TableCell, Skeleton, TextField, Chip } from "@mui/material";
import axios from "axios";
import _ from "lodash";
import moment from 'moment-timezone';


const config = {
  headers: {
    "Content-Type": "application/json"
  },
  withCredentials: true
};

const formatPhoneNumberToE164 = (phoneNumber) => {
  if (phoneNumber !== '' && phoneNumber !== null) {
    const numericPhoneNumber = phoneNumber?.replace(/\D/g, '');
    return numericPhoneNumber?.length === 10 ? `+1${numericPhoneNumber}` : `+${numericPhoneNumber}`;
  }
}

const PictureBlastModal = ({ isModalOpen, openModal, vendorId }) => {
  const [truckList, setTruckList] = useState([])
  const [loading, setLoading] = useState(true)
  const [searchVendor, setSearchVendor] = useState('')
  const [isVendorSearchLoading, setIsVendorSearchLoading] = useState(false)
  const [vendors, setVendors] = useState([])
  const [selectedVendorId, setSelectedVendorId] = useState(null)
  const [selectedVendor, setSelectedVendor] = useState(null)

  useEffect(() => {
    getAllCampaignTrucks()

    return () => {
      setTruckList([]);
      setLoading(true);
      setSearchVendor('');
      setIsVendorSearchLoading(false);
      setVendors([]);
      setSelectedVendorId(null);
      setSelectedVendor(null);
    };
  }, [])

  const getAllCampaignTrucks = async (vendor = null) => {
    if(vendor === null) {
      let res = await axios.get(`${process.env.REACT_APP_API_HOST}/comunication/campaign-trucks?vendor_id=${vendorId}`);
      if (res?.data?.campaignTrucks?.length > 0) {
        setTruckList([...res?.data?.campaignTrucks])
        setLoading(false)
      } else {
        setTruckList([])
        setLoading(false)
      }
    } else {
      setSelectedVendorId(vendor)
      let res = await axios.get(`${process.env.REACT_APP_API_HOST}/comunication/campaign-trucks?vendor_id=${vendor}`);
      if (res?.data?.campaignTrucks?.length > 0) {
        setTruckList([...res?.data?.campaignTrucks])
        setLoading(false)
      } else {
        setTruckList([])
        setLoading(false)
      }
    }
  }

  const searchVendors = async () => {
    try {
      setIsVendorSearchLoading(true);
      const res = await axios.get(`${process.env.REACT_APP_API_HOST}/communication/chat/search-vendor/${searchVendor}`);
      console.log(res.data.vendors);
      setVendors(res.data.vendors)
      setIsVendorSearchLoading(false);
    } catch (error) {
      setIsVendorSearchLoading(false);
      console.error(error)
    }
  }

  const approveRejectTruckHandler = async (item, value) => {
    item.status_value = value
    if (!item.status_id) {
      let data = _.omit(item, ['phone_number', 'status_id', 'truck_name', 'license_plate', 'campaign_display_name'])
      setLoading(true)
      let res = await axios.post(`${process.env.REACT_APP_API_HOST}/comunication/approve-disapprove-campaign-trucks`, data, config);
      if (!res) {
        setLoading(false)
      } else {
        if(vendorId === -1){
          await getAllCampaignTrucks(selectedVendorId)
        }else {
          await getAllCampaignTrucks()
        }
      }
    }

    if (item.status_id) {
      let data = _.omit(item, ['phone_number', 'truck_id', 'vendor_id', 'truck_name', 'license_plate', 'campaign_display_name'])
      setLoading(true)
      let res = await axios.put(`${process.env.REACT_APP_API_HOST}/comunication/approve-disapprove-campaign-trucks`, data, config);
      if (!res) {
        setLoading(false)
      } else {
        if(vendorId === -1){
          await getAllCampaignTrucks(selectedVendorId)
        }else {
          await getAllCampaignTrucks()
        }
      }
    }

    if (truckList.every(item => item.status_value === 1)) {
      setLoading(true)
      let res = removeFromPictures(formatPhoneNumberToE164(item.phone_number));
      let res2 = removeFromPictureReporting()
      if (!res) {
        setLoading(false)
      } else {
        if(vendorId === -1){
          await getAllCampaignTrucks(selectedVendorId)
        }else {
          await getAllCampaignTrucks()
        }
      }

    }
  }


  const removeFromPictureReporting = async () => {
    try {
      setTimeout(() => {
        openModal(false)
      }, 1000);
    } catch (e) {
      console.log(e)
    }
  }
  const removeFromPictures = async (phone_number) => {
    try {
      await axios.delete(`${process.env.REACT_APP_API_HOST}/communication/remove-pictures/${phone_number}`);
    } catch (error) {
      console.log(error);
    }
  }

  const onSearchVendorClickHandler = (vendor) => {
    setLoading(true)
    getAllCampaignTrucks(vendor.vendor_id)
    setSelectedVendor(vendor)
  }
  return (
    <Modal backdrop="static" className={classes.modalDialog} isOpen={isModalOpen}>
      <ModalHeader >Trucks on Campaign</ModalHeader>
      <ModalBody style={{ position: 'relative' }}>
        <section className={classes.wrapper}>
          {selectedVendorId && vendorId === -1 && (
            <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%'}}>
              <ArrowBackIosOutlinedIcon style={{ cursor: 'pointer'}} color="primary" onClick={() => {
                setSearchVendor('');
                setIsVendorSearchLoading(false);
                setVendors([]);
                setTruckList([])
                setSelectedVendorId(null);
                setSelectedVendor(null);

              }}/>
            <Chip
            color="primary"
            key={selectedVendorId}
            label={`${selectedVendor?.name}`}
          />
            </div>
          )}
          {loading &&
            (
              <div className={classes.loadingState}>
                <Spinner style={{ color: boxiPrimary }}></Spinner>
                <div>Loading Trucks on Campaigns...</div>
              </div>
            )}
          {vendorId === -1 && !loading && truckList.length === 0 && !selectedVendorId && (
            <>
              <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                <TextField
                  id="standard-search"
                  label="Search Vendor"
                  variant="outlined"
                  value={searchVendor}
                  style={{ flex: '0 0 88%', borderRadius: '10px'}}
                  onChange={(e) => setSearchVendor(e.target.value)}
                />
                <Button2 style={{
                                borderRadius: '10px',
                                border: '1px solid' + boxiPrimary
                              }} disabled={isVendorSearchLoading} color="primary" onClick={searchVendors}>Search</Button2>
              </div>
              {vendors.length > 0 && <div className={classes.searchVendorList}>
                {vendors.map((vendor, index) => {
                  return (
                    <div className={classes.searchVendor} style={{ cursor: 'pointer', filter: `'contrast(1)` }} onClick={() => {
                      onSearchVendorClickHandler(vendor)
                      }}>
                      <div className={classes.vendorName}>{vendor.name}</div>
                      <div className={classes.vendorPhone}>{vendor.phone_num}</div>
                    </div>
                  )
                })}
              </div>}
              {isVendorSearchLoading && vendors.length === 0 && (
                <div className={classes.loadingState}>
                <Spinner style={{ color: boxiPrimary }}></Spinner>
                <div>Loading Vendors...</div>
              </div>
              )}
            </>
          )}
          {!loading && truckList.length > 0 && (
            <TableContainer>
              <Table aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell align="center">Campaign Name</TableCell>
                    <TableCell align="center">Truck Name</TableCell>
                    <TableCell align="center">License Plate</TableCell>
                    <TableCell align="center">Approve</TableCell>
                    <TableCell align="center">Reject</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {truckList.map((row) => {
                    let isCurrentMonth = false;
                    if (row.created_at !== null) {
                      const timestamp = moment.tz(row.created_at, 'America/Los_Angeles');
                      const currentDateTime = moment.tz('America/Los_Angeles');
                      isCurrentMonth = timestamp.isSame(currentDateTime, 'month');
                    }
                    return (
                      <TableRow
                        style={{
                          height: '50px'
                        }}
                        key={row.status_id}
                        sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                      >
                        <TableCell align="center">{row.campaign_display_name}</TableCell>
                        <TableCell align="center">{row.truck_name}</TableCell>
                        <TableCell align="center">{row.license_plate}</TableCell>
                        <TableCell align="center">
                          {row.status_value === 1 && isCurrentMonth ? (
                            <ThumbUpIcon style={{ color: '#009E60', margin: '0px 10px' }} />
                          ) : (
                            <ThumbUpAltOutlinedIcon
                              style={{ color: '#009E60', cursor: 'pointer', margin: '0px 10px' }}
                              onClick={(e) => {
                                e.preventDefault();
                                approveRejectTruckHandler(row, 1);
                              }}
                            />
                          )}
                        </TableCell>
                        <TableCell align="center">
                          {row.status_value === 0 && isCurrentMonth ? (
                            <ThumbDownAltIcon style={{ color: boxiRed, margin: '0px 10px' }} />
                          ) : (
                            <ThumbDownOutlinedIcon
                              style={{ color: boxiRed, cursor: 'pointer', margin: '0px 10px' }}
                              onClick={(e) => {
                                e.preventDefault();
                                approveRejectTruckHandler(row, 0);
                              }}
                            />
                          )}
                        </TableCell>
                      </TableRow>
                    )
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          )}
          <hr/>
          {!loading && truckList.length === 0 && vendorId !== -1 && (
            <div style={{ display: 'flex', alignSelf: 'center', justifyContent: 'center' }}>
              No Record Found.
            </div>
          )}
          {!loading && truckList.length === 0 && vendorId === -1 && selectedVendorId && (
            <div style={{ display: 'flex', alignSelf: 'center', justifyContent: 'center' }}>
              No Record Found.
            </div>
          )}
        </section>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={() => openModal(false)}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default PictureBlastModal